// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"643":"f354ade520914e31","915":"e32e3afd3e551b48"}[chunkId] + ".js";
};